import React from 'react';
import { ModelsFilterPanel } from './ModelsFilterPanel';
import { ModelsTagsPanel } from './ModelsTagsPanel';
interface ModelsCatalogPanelProps {
  modelSearch: string;
  setModelSearch: (search: string) => void;
  showOnlyModelFavorites: boolean;
  setShowOnlyModelFavorites: (show: boolean) => void;
  showOnlySelectedModels: boolean;
  setShowOnlySelectedModels: (show: boolean) => void;
  kitchenModels: any[];
}
export function ModelsCatalogPanel({
  modelSearch,
  setModelSearch,
  showOnlyModelFavorites,
  setShowOnlyModelFavorites,
  showOnlySelectedModels,
  setShowOnlySelectedModels,
  kitchenModels
}: ModelsCatalogPanelProps) {
  return <div className="flex-1 overflow-y-auto p-4" data-id="element-867">
      <ModelsFilterPanel modelSearch={modelSearch} setModelSearch={setModelSearch} showOnlyModelFavorites={showOnlyModelFavorites} setShowOnlyModelFavorites={setShowOnlyModelFavorites} showOnlySelectedModels={showOnlySelectedModels} setShowOnlySelectedModels={setShowOnlySelectedModels} data-id="element-868" />
      <div className="flex gap-4" data-id="element-869">
        {/* Models grid - consistently 2 columns */}
        <div className="grid grid-cols-2 gap-3 flex-1" data-id="element-870">
          {kitchenModels.map(model => {
          return <div key={model.id} className="relative group border border-gray-200 rounded-lg overflow-hidden bg-white dark:bg-darkbg-secondary dark:border-darkbg-border cursor-pointer hover:shadow-sm" data-id="element-871">
                <div className="flex justify-center items-center p-3 h-24" data-id="element-872">
                  {/* Model preview image */}
                  <div className="w-16 h-16 rounded-full shadow-sm overflow-hidden" data-id="element-873">
                    <img src={model.image} alt={model.name} className="w-full h-full object-cover" data-id="element-874" />
                  </div>
                </div>
                <div className="px-3 pb-3 text-center" data-id="element-875">
                  <p className="text-xs font-medium text-gray-800 dark:text-gray-200 truncate" data-id="element-876">
                    {model.name}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-877">
                    {model.category}
                  </p>
                </div>
              </div>;
        })}
        </div>
        <ModelsTagsPanel data-id="element-878" />
      </div>
      {/* Show message if no models match the filter */}
      {kitchenModels.length === 0 && <div className="text-center py-8" data-id="element-879">
          <p className="text-base text-gray-500 dark:text-gray-400" data-id="element-880">
            No models match the current filters.
          </p>
          <button className="mt-3 text-sm text-blue-600 hover:text-blue-800 dark:text-accent-blue dark:hover:text-blue-400" onClick={() => {
        setModelSearch('');
        setShowOnlyModelFavorites(false);
        setShowOnlySelectedModels(false);
      }} data-id="element-881">
            Clear filters
          </button>
        </div>}
    </div>;
}